import { BCMSCurrency, BCMSDate } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView } from "components/shared";
import React from "react";

/**
 * @function TASPositivePayCreateTemplateFileMappingPreviewTableRow
 * @return {React.Component}
 * @exported true
 * @description The Import File Mapping Preview table row for the ImportFileMappingPreviewTable.
 */
export default function TASPositivePayCreateTemplateFileMappingPreviewTableRow(props) {
    const fileRow = props.data;
    const dataPointCheckDate = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Check_Date_Value_${ fileRow.id }` } : {};
    const dataPointCheckNumber = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Check_Number_Value_${ fileRow.id }` } : {};
    const dataPointBusiness = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Business_Value_${ fileRow.id }` } : {};
    const dataPointAccountNumber = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Account_Number_Value_${ fileRow.id }` } : {};
    const dataPointAccountNickname = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Account_Nickname_Value_${ fileRow.id }` } : {};
    const dataPointPayee = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Payee_Value_${ fileRow.id }` } : {};
    const dataPointAmount = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Amount_Value_${ fileRow.id }` } : {};
    const dataPointStatus = props.dataPoint ? { "data-point": `Mapping_Preview_File_Row_Status_Value_${ fileRow.id }` } : {};
    const checkDate = isNaN(fileRow.checkDate) ? fileRow.checkDate : BCMSDate.init().offset(fileRow.checkDate).format("m/d/Y")
    const amount = isNaN(fileRow.amount) ? fileRow.amount : BCMSCurrency.init(fileRow.amount).format();

    return (
        <TableItemContainer>
            <TableItemTextView className="column-item column-one" { ...dataPointCheckDate } text={ `"${ checkDate }"` } />
            <TableItemTextView className="column-item column-two" { ...dataPointCheckNumber } text={ `"${ fileRow.checkNumber }"` } />
            <TableItemTextView className="column-item column-three" { ...dataPointBusiness } text={ `"${ fileRow.business }"` } />
            <TableItemTextView className="column-item column-four" { ...dataPointAccountNumber } text={ `"${ fileRow.accountNumber }"` } />
            <TableItemTextView className="column-item column-five" { ...dataPointAccountNickname } text={ `"${ fileRow.accountNickname }"` } />
            <TableItemTextView className="column-item column-six" { ...dataPointPayee } text={ `"${ fileRow.payee }"` } />
            <TableItemTextView className="column-item column-seven" { ...dataPointAmount } text={ `"${ amount }"` } />
            <TableItemTextView className="column-item column-eight" { ...dataPointStatus } text={ `"${ fileRow.status }"` } />
        </TableItemContainer>
    )
}
